import { Heart } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Seo } from "@/components/Seo";

export default function About() {
  return (
    <div>
       <Seo
         title="About"
         description="My Theatre is an independent West End theatre tracker for shows, cast changes and ticket prices."
/>
      <PageHero
        offset={1}
        overline="Our story"
        title="About My Theatre"
        callout={{
          icon: Heart,
          lead: "Built for theatre lovers.",
          text: "One simple place to track the shows and performers you care about, compare ticket prices, and never miss a cast change.",
        }}
      />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6">
        <div className="space-y-4 text-foreground/80">
          <p>
            My Theatre was built for people who genuinely love West End theatre and want one simple place to
            keep track of the shows and performers they care about.
          </p>
          <p>
            Instead of checking multiple sites for cast changes, closing dates, and news, My Theatre brings it
            all together — with alerts the moment something changes for a show or actor you're following.
          </p>
          <p>This site is independently run and is not affiliated with any West End theatre, production, or ticketing provider.</p>
        </div>
        <p className="mt-10 text-right text-sm text-muted-foreground"></p>
      </div>
    </div>
  );
}